import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import TwitterCampaigns from "./twitterCampaigns";

const Channel = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  console.log(id);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <div className="flex gap-1 md:gap-4 items-center">
        <button className="" onClick={() => navigate(-1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
        </button>
        <h1 className="md:text-xl text-lg capitalize">
          Social Channels / {id.toLocaleLowerCase().replace("-", " ")}{" "}
        </h1>
      </div>

      {id === "twitter-campaigns" ? <TwitterCampaigns /> : null}
    </div>
  );
};

export default Channel;
